<div class="container-fluid" style="margin-top: 100px;">
    <!-- Manifesto -->
    <manifesto></manifesto>

    <!-- Contact Us -->
    <app-contact-us></app-contact-us>
</div>